export const getIntersectingIcons = state =>
  state.iconButtons.intersectingIcons;
